import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ErrorState = {
  status: number;
  title: string;
  message?: string;
};

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private errorSubject = new BehaviorSubject<ErrorState | null>(null);
  error$ = this.errorSubject.asObservable();

  setError(error: ErrorState): void {
    this.errorSubject.next(error);
  }

  clearError(): void {
    this.errorSubject.next(null);
  }

  getError(): ErrorState | null {
    return this.errorSubject.value;
  }
}
